/* eslint-disable no-use-before-define */
import React from 'react'
import { format } from '../../twd'

export default ({type='ask', rows=[], allowTrading=true} = {}) => {
    let header = type==='ask'
        ? {backgroundColor:'green'}
        : {backgroundColor:'red'}
    let title = type==='ask'
        ? 'OFFERS'
        : 'BIDS'
    let action = allowTrading===false
        ? format.orderPhone
        : (type==='ask' ?  format.buy : format.sell)

    return <React.Fragment>
        <div className="text-center vertical-offset-xxs" style={{
            color:'#ffffff',
            ...header
        }}>{title}</div>
        <div className="table-responsive">
        <table
            data-name={'offerings-depth-of-market-table-' + type}
            className="table table-striped"
            style={{
                marginBottom: 0,
            }}
        >
        <thead>
            <tr>
            <th>Qty</th>
            <th>Min</th>
            <th>Price</th>
            <th className="text-right">Yield</th>
            <th className="text-right">Updated</th>
            <th className="text-right">Action</th>
            </tr>
        </thead>
        <tbody>{
            rows && rows.map((r,i) => {
                return <tr key={i}>
                    <td>{format.qty(r.quantity)}</td>
                    <td>{format.qty(r.qty_min)}</td>
                    <td>{format.price(r.price)}</td>
                    <td className="text-right">{format.ytw(r.yield)}</td>
                    <td className="text-right">{r.price_status}</td>
                    <td className="text-right">{
                        action({cusip:''+r.cusip, from:'offerings'})
                    }</td>
                </tr>
            })
        }</tbody>
        </table>
        </div>
    </React.Fragment>
}